/** @jsx jsx */
import React, { type MouseEvent, type KeyboardEvent } from 'react';
import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import type { CommandRowProps, ListedCommand } from '../../../../types/commands/index.tsx';
import { getAnalyticsAttributesFromResult } from '../../../../utils.tsx';
import { CommandRow as CommandRowNew } from '../../command-row/index.tsx';

const styles = cssMap({
	rowWrapper: {
		paddingInlineStart: token('space.050'),
		paddingInlineEnd: token('space.050'),
	},
});

type Props = {
	index: number;
	result: ListedCommand;
	isSearchFieldFocused?: boolean;
	onHoverCommand: (event: MouseEvent) => void;
	onClickCommand: (event: MouseEvent | KeyboardEvent) => void;
	onMouseDownCommand: (event: MouseEvent) => void;
};

export const CommandRow = ({
	index,
	result,
	isSearchFieldFocused,
	onHoverCommand,
	onClickCommand,
	onMouseDownCommand,
}: Props): React.JSX.Element => {
	const { command } = result;
	const isActive = !!(result.active && isSearchFieldFocused);
	const isFirstCommand = result.index === 0;

	const rowProps: CommandRowProps = {
		index,
		isActive,
		command,
		isFirstCommand,
		...(fg('dee-8683-compal-a11y-button-keyboard-accessibility') && {
			isLinkFocused: !!command.components?.CommandRow,
		}),
		onMouseMove: onHoverCommand,
		onClick: onClickCommand,
		onMouseDown: onMouseDownCommand,
		analyticsAttributes: getAnalyticsAttributesFromResult(result),
	};

	if (fg('dee-8683-compal-a11y-button-keyboard-accessibility')) {
		return (
			<div css={styles.rowWrapper}>
				{command.components?.CommandRow ? (
					<command.components.CommandRow {...rowProps} />
				) : (
					<CommandRowNew {...rowProps} />
				)}
			</div>
		);
	}

	if (command.components?.CommandRow) {
		return <command.components.CommandRow {...rowProps} />;
	}

	return <CommandRowNew {...rowProps} />;
};
